module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEsSURBVEhL7dQxSwJhHMfxp2hobGzsBTQ4NAYhIiQtCS4OkkHgFCIOCi5u0itodWxs0yYJ3QwK6gUUNLQEDQ4NDn5/dz5SF3c9HrrdDz4+z+Odz/+ex+MxSZKsLRvztowzv7vSXKFvi7RRxxS68IG42UXL75pLdP2uX2SAQzziGHGi3z3PW82nHTKb+viREdKooIMtuET36f4qsuhjkWAR5Qt5vEFPs4eo6PoQn8ghdKvtdgWzD01Q8EZ/o+/HOPBGvxO6XcG8QMs/wjW2oajV+ATa3geE5r8iyjf0ltyhh1PoKe9xjgki41LE5hYlZFDEDZxii+jPdsk7tKpXbxQdzbmjzjIriZ2kyFKxB2QTDTx5o9UkhRq6tohOzgu4nlUu0YmuE1hvZBLXGDMDBloxa7B9MMwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/VPRekla/EditComplaint/DocumentTab/envelope.png
// module id = 877
// module chunks = 0